export default __webpack_public_path__ + "static/media/j1.3c7e79e5.JPG";